import Vue from 'vue'
import Vuex from 'vuex'

// 挂载Vuex
Vue.use(Vuex)

// 创建VueX对象
const store = new Vuex.Store({
	state: {
		// 存放的键值对就是所要管理的状态
		name: 'name',
		navList: [],
		projectList: [],		 // 项目列表
		gray: false,    // 首页是否置灰
	},
	mutations: {
		// es6语法，等同edit:funcion(){...}
		edit(state,name) {
			state.name = name
		},
		EDITNAVLIST (state,list) {
			state.navList = list
		},
		SET_PROJECT (state,list) {
			state.projectList = list
		},
		SETGRAY(state,gray){
			state.gray = gray
		}
	}
})

export default store
